import ApiProvider from '../../core/api/ApiProvider';
import { IDictionary } from '../types/IDictionary';
import { ITranslationCollection } from '../types/ITranslationCollection';
import { ILanguage } from '../types/ILanguage';

class TranslationsApiClient
{
    public async GetAllTranslations(): Promise<IDictionary<ITranslationCollection>> {
        return await ApiProvider.get<IDictionary<ITranslationCollection>>('Translation/getTranslations');
    }

    public async GetLanguages(): Promise<ILanguage[]> {
        return await ApiProvider.get<ILanguage[]>('Translation/languages');
    }
}

export default new TranslationsApiClient();